export default __webpack_public_path__ + "static/media/ClarinetFailSound.a22723df.mp3";